import { isNil } from 'lodash'

export const mapDisciplineSpecialty = (items, propKey, labelKey) =>
	items
		?.filter((item) => !isNil(item[propKey]))
		.map((item) => {
			const prop = item[propKey] || {}
			return {
				label: prop[labelKey],
				value: prop.id,
			}
		}) || []
